export const Topups = {
  LOADING_TOPUP_REQUESTS: "LOADING_TOPUP_REQUESTS",
  GET_TOPUP_REQUESTS: "GET_TOPUP_REQUESTS",
};
